(() => {
  const root = document.querySelector('[data-singles-filter-root]');
  const grid = root?.querySelector('[data-catalogue-grid]');
  const setFilter = root?.querySelector('[data-set-filter]');
  const selectedSet = setFilter?.selectedOptions[0]?.textContent?.trim().toLowerCase() ?? '';
  if (!root || !grid || !selectedSet || selectedSet === 'popular cards' || root.dataset.cardOrderLoading) return;

  root.dataset.cardOrderLoading = 'true';
  const pageSize = 130;
  const currentUrl = new URL(window.location.href);
  const currentPage = Math.max(1, Number(currentUrl.searchParams.get('page')) || 1);
  const pageLinks = Array.from(root.querySelectorAll('.pagination--shop .pagination-panel__number'));
  const maxPage = Math.max(currentPage, ...pageLinks.map((link) => Number(link.textContent.trim()) || 0));
  const currentCards = Array.from(grid.querySelectorAll('[data-product-card]'));

  const loadPageCards = async (page) => {
    if (page === currentPage) return currentCards;
    const pageUrl = new URL(currentUrl);
    pageUrl.hash = '';
    pageUrl.searchParams.set('page', String(page));
    pageUrl.searchParams.set('browse', 'all');
    const response = await fetch(pageUrl.toString(), { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Unable to load another card page for sorting.');
    const html = await response.text();
    const pageDocument = new DOMParser().parseFromString(html, 'text/html');
    const pageGrid = pageDocument.querySelector('[data-catalogue-grid]');
    return pageGrid ? Array.from(pageGrid.querySelectorAll('[data-product-card]')) : [];
  };

  const cardNumber = (card) => {
    const match = (card.dataset.title || '').match(/(?:#|\b)(\d{1,3})\s*\/\s*(\d{1,3})\b/);
    return match ? { number: Number(match[1]), total: Number(match[2]) } : { number: Number.MAX_SAFE_INTEGER, total: Number.MAX_SAFE_INTEGER };
  };

  const compareCards = (first, second) => {
    const firstAvailability = first.dataset.available === 'false' || first.querySelector('.soldout') ? 1 : 0;
    const secondAvailability = second.dataset.available === 'false' || second.querySelector('.soldout') ? 1 : 0;
    if (firstAvailability !== secondAvailability) return firstAvailability - secondAvailability;
    const firstNumber = cardNumber(first);
    const secondNumber = cardNumber(second);
    return firstNumber.number - secondNumber.number
      || firstNumber.total - secondNumber.total
      || (first.dataset.title || '').localeCompare(second.dataset.title || '', undefined, { numeric: true });
  };

  Promise.all(Array.from({ length: maxPage }, (_, index) => loadPageCards(index + 1)))
    .then((pages) => {
      const allCards = pages.flat();
      allCards.sort(compareCards);
      const start = (currentPage - 1) * pageSize;
      grid.replaceChildren(...allCards.slice(start, start + pageSize));
      root.dataset.cardOrderLoading = 'done';
    })
    .catch((error) => {
      currentCards.sort(compareCards);
      grid.replaceChildren(...currentCards);
      root.dataset.cardOrderLoading = 'partial';
      console.warn('Stock-first card ordering could not include every page.', error);
    });
})();